import { BaseService } from "core/services";
import { FacilityOrderRouteService } from "application/facility-order/services";

class FacilityOrderService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new FacilityOrderRouteService());
	}

	getStatistic(facilityId) {
		const url = this.routeService.getStatistic(facilityId);
		return this.apiClient.get(url);
	}

	importFacilityOrder(resource) {
		const url = this.routeService.importFacilityOrder(resource);
		return this.apiClient.put(url, resource);
	}

	isReadyForImportFacilityOrder(resource) {
		const url = this.routeService.isReadyForImportFacilityOrder(resource);
		return this.apiClient.get(url);
	}

	setDateInitialReviewCompleted(resource) {
		const url = this.routeService.setDateInitialReviewCompleted(resource);
		return this.apiClient.put(url, resource);
	}

	setInsuranceReviewCompletedDate(resource) {
		const url = this.routeService.setInsuranceReviewCompletedDate(resource);
		return this.apiClient.put(url, resource);
	}

	setMissingInventoryCount(resource) {
		const url = this.routeService.setMissingInventoryCount(resource);
		return this.apiClient.put(url, resource);
	}

	setNikoMissingInventoryCount(resource) {
		const url = this.routeService.setNikoMissingInventoryCount(resource);
		return this.apiClient.put(url, resource);
	}

	importFacilityOrderNewFlow(resource) {
		const url = this.routeService.importFacilityOrderNewFlow(resource);
		return this.apiClient.put(url, resource);
	}

	get(id, options) {
		const url = this.routeService.get(id, options);
		return this.apiClient.get(url);
	}

	markInventoryReportAsSent(id, requestType) {
		const url = this.routeService.markInventoryReportAsSent(id, requestType);
		return this.apiClient.put(url, id);
	}

	checkPreviousFacilityOrders(id) {
		const url = this.routeService.checkPreviousFacilityOrders(id);
		return this.apiClient.get(url);
	}

	async createCsv(resource) {
		var formData = new FormData();
		formData.append('file', resource.file);
		formData.append('facilityId', resource.facilityId);

		let dateOfService = new Date(resource.dateOfService);
		dateOfService.setUTCHours(12, 0, 0, 0);

		const formattedDate = dateOfService.toLocaleString('en-US', {
			year: 'numeric',
			month: '2-digit',
			day: '2-digit',
			hour: '2-digit',
			minute: '2-digit',
			hour12: false
		}).replace(',', '');

		formData.append('dateOfService', formattedDate);

		const url = this.routeService.createCsv(formData);
		const response = await this.apiClient.post(url, formData);
		return response.data || null;
	}

	getTargetPage(id) {
		const url = this.routeService.getTargetPage(id);
		return this.apiClient.get(url);
	}

	getNikoTargetPage(id) {
		const url = this.routeService.getNikoTargetPage(id);
		return this.apiClient.get(url);
	}

	isInventoryStepAllowed(id) {
		const url = this.routeService.isInventoryStepAllowed(id);
		return this.apiClient.get(url);
	}

	isNikoInventoryStepAllowed(id) {
		const url = this.routeService.isNikoInventoryStepAllowed(id);
		return this.apiClient.get(url);
	}

	getSentEmailInfo(facilityOrderId, emailType) {
		const url = this.routeService.getSentEmailInfo(facilityOrderId, emailType);
		return this.apiClient.get(url);
	}

	hasSentEmail(facilityOrderId, emailType) {
		const url = this.routeService.hasSentEmail(facilityOrderId, emailType);
		return this.apiClient.get(url);
	}

	hasPrimaryRecipient(facilityOrderId) {
		const url = this.routeService.hasPrimaryRecipient(facilityOrderId);
		return this.apiClient.get(url);
	}

	hasPrimaryRecipientNiko(facilityOrderId) {
		const url = this.routeService.hasPrimaryRecipientNiko(facilityOrderId);
		return this.apiClient.get(url);
	}

	importCheckNiko(id) {
		const url = this.routeService.importCheckNiko(id);
		return this.apiClient.get(url);
	}

	sendPackingListEmail() {
		const url = this.routeService.sendPackingListEmail();
		return this.apiClient.put(url);
	}

	sendNikoPackingListEmail() {
		const url = this.routeService.sendNikoPackingListEmail();
		return this.apiClient.put(url);
	}

	sendNikoPackingListEmailSingle(facilityOrderId) {
		const url = this.routeService.sendNikoPackingListEmailSingle(facilityOrderId);
		return this.apiClient.put(url);
	}

	createNikoFacilityOrder(facilityScheduleDateId) {
		const url = this.routeService.createNikoFacilityOrder(facilityScheduleDateId);
		return this.apiClient.post(url);
	}

	deleteNikoFacilityOrder(resource) {
		const url = this.routeService.deleteNikoFacilityOrder(resource);
		return this.apiClient.delete(url, null, resource);
	}

	sendOrder(resource) {
		const url = this.routeService.sendOrder(resource);
		return this.apiClient.put(url, resource);
	}

	addIvPoles(resource) {
		const url = this.routeService.addIvPoles(resource);
		return this.apiClient.put(url, resource);
	}

	hasBackorderedItemNiko(id) {
		const url = this.routeService.hasBackorderedItemNiko(id);
		return this.apiClient.get(url);
	}

	createNikoSOs(facilityOrderId) {
		const url = this.routeService.createNikoSOs(facilityOrderId);
		return this.apiClient.post(url);
	}

	createNikoSOsAllFacilityOrders() {
		const url = this.routeService.createNikoSOsAllFacilityOrders();
		return this.apiClient.post(url);
	}

	createNikoInvoicesAllFacilityOrders() {
		const url = this.routeService.createNikoInvoicesAllFacilityOrders();
		return this.apiClient.post(url);
	}

	createNikoInvoices(facilityOrderId) {
		const url = this.routeService.createNikoInvoices(facilityOrderId);
		return this.apiClient.post(url);
	}
}

export default FacilityOrderService;